define([
    'handlebars',
    'modules/common/controls/control',
    'modules/common/controls/checklist',
    'modules/common/templates/checklistmodal.html',
    'appcontext'
], (Handlebars, Control, CheckList, Template, appContext) => Control.extend({

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.get());
                };
                view.on('change', this.callback);
            },
            unbind (view) {
                view.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        }
    },

    template: Handlebars.compile(Template),

    defaults: _.extend({}, Control.prototype.defaults, {
        id: 'id',
        text: 'text'
    }),

    events: {
        'click .btn-edit': 'edit',
        'click .btn-modal-submit': 'submit'
    },

    initialize () {
        Control.prototype.initialize.apply(this, arguments);
        _.defaults(this.options, {title: appContext.tr('Edit'), empty: appContext.tr('(empty)')});
        this.choices = this.options.choices;
        this.checked = [];

        this.checkList = new CheckList({choices: this.choices, id: this.options.id, text: this.options.text});
    },

    render () {
        const self = this;

        this.checkList.
            render().
            applyBindings().
            delegateEvents();

        this.$el.html(this.template({title: this.options.title}));
        this.$('.modal').modal({show: false}).
            bind('hide', () => {
                if (self.deferred.state() === 'pending') {
                    self.deferred.reject();
                }
            });
        this.$('.modal-body').html(this.checkList.el);
        return this;
    },

    get () {
        return this.checked;
    },

    set (value) {
        this.checked = value;
        this.renderDescription();
    },

    execute (checked) {
        this.checkList.set(checked);
        this.$('.modal').modal('show');
        this.deferred = $.Deferred();
        return this.deferred.promise();
    },

    submit () {
        this.deferred.resolve(this.checkList.get());
        this.$('.modal').modal('hide');
    },

    edit () {
        const self = this;
        this.execute(this.checked).done((newChecked) => {
            self.set(newChecked);
            self.trigger('change');
        });
    },

    renderDescription () {
        const choices = this.choices;
        const description = this.checked.map(function (id) {
            return choices.get(id).get(this.options.text);
        }, this).join(', ');
        this.$('.checked-description').html(description || this.options.empty);
    }

}));
